module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/13-36633d5210acd7cb831fc25ecba39a83.png";